module.exports = __webpack_public_path__ + "static/kompass-041d9e1035e0424641f0541b7c2628d3.png";